import React, { useEffect, useState } from 'react';
import AdminDesk from './AdminDesk';
import AdminLogin from './AdminLogin';
import logo from '../../Images/KonjoImage.png';
import firebase from '../../../firebase';
import { adminCheck, callableErrorMessage, signOutAdmin } from '../../../adminApi';
import './admin.css';

function AdminPage() {
  const [authUser, setAuthUser] = useState(undefined);
  const [isAdmin, setIsAdmin] = useState(false);
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    document.title = 'Admin · Konjo';
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    robots.setAttribute('content', 'noindex, nofollow');

    let font = document.querySelector('link[data-admin-font="true"]');
    if (!font) {
      font = document.createElement('link');
      font.setAttribute('rel', 'stylesheet');
      font.setAttribute('data-admin-font', 'true');
      font.setAttribute('href', 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
      document.head.appendChild(font);
    }

    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      setAuthUser(user || null);
      if (!user) {
        setIsAdmin(false);
        setChecking(false);
        return;
      }
      setChecking(true);
      adminCheck()
        .then(() => {
          setIsAdmin(true);
          setError('');
        })
        .catch((err) => {
          setIsAdmin(false);
          setError(callableErrorMessage(err) === 'Not an admin.' ? 'Not an admin.' : callableErrorMessage(err));
          return signOutAdmin();
        })
        .finally(() => setChecking(false));
    });

    return () => {
      unsubscribe();
      document.title = 'Konjo ቆንጆ';
      if (robots) {
        robots.setAttribute('content', 'index, follow');
      }
    };
  }, []);

  return (
    <div className="admin-app">
      <header className="admin-header">
        <a className="admin-logo" href="/">
          <img src={logo} alt="" />
          <strong>Konjo Admin</strong>
        </a>
        {isAdmin && authUser ? (
          <div className="admin-header-session">
            <p>{authUser.email}</p>
            <button type="button" className="admin-btn admin-btn--secondary" onClick={() => signOutAdmin()}>
              Signout
            </button>
          </div>
        ) : null}
      </header>
      {checking || authUser === undefined ? (
        <main className="admin-login">
          <p className="admin-muted">Checking session…</p>
        </main>
      ) : isAdmin ? (
        <AdminDesk />
      ) : (
        <AdminLogin error={error} />
      )}
    </div>
  );
}

export default AdminPage;
